import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../../pageheader/PageHeader";
import MenuDoctor from "../navDoctor/MenuDoctor";
import Input from "../../material/input/Input";
import Select from "../../material/select/Select";
import Checkbox from "../../material/checkbox/Checkbox";
import { HashLoader } from "react-spinners";
import * as publicApi from "../../../service/publicApi";
import * as userApi from "../../../service/userApi";
import * as regex from "../../../service/regex";
import * as uplevelApi from "../../../service/uplevelByThaid";
import moment from "moment/moment";
import "moment/locale/th";
import { CurrentUserContext } from "../../../App";
import styles from "./TableDataAccess.module.css";
import stylesPer from "../../public/permissionDoctor/PermissionDoctor.module.css";
import Datepicker from "../../material/datepicker/Datepicker";

import AutoComplete from "../../material/autoComplete/AutoComplete";

import { environment } from "../../../config.env";
import { Tooltip, Typography } from "@material-tailwind/react";
import iconDID from "../../../asset/icon/DID.svg";
import iconThaiID from "../../../asset/icon/thaiId.svg";
import icon from "../../../asset/icon/icon-detail.svg";
import HeadBar from "../../public/headBar/HeadBar";
import CheckBoxV3 from "../../material/checkboxV3/CheckBoxV3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "../../public/breacrumb/breadcrumb";
import Footer from "../../footer/Footer";
import { useLocation } from "react-router-dom";

const ENDPOINT_MOHPROMT = environment.mohpromt_url || "";
const ENDPOINT_MOHPROMT_CLIENT_ID = environment.mohpromt_client_id || "";
const REDIRECT_DOMAIN = environment.redirect_domain || "";

function ManageInfo({ role }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [getImgDefault, setGetImgDefault] = useState(null);
  const [actionState, setActionState] = useState(""); //เอ่ไว้สั่งให้ api get data หลังบันทึก
  const [showImageList, setShowImageList] = useState([]);
  const [pname, setPname] = useState("");
  const [pid, setPid] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [lisenceNumber, setLisenceNumber] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [address, setAddress] = useState("");
  const [postCode, setPostCode] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState("");
  const [hospitalList, setHospitalList] = useState("");
  const [hospitalId, setHospitalId] = useState("");

  const [provinceId, setProvinceId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setSubDistrictId] = useState("");

  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);

  const [road, setRoad] = useState(null);
  const [building, setBuilding] = useState(null);
  const [moo, setMoo] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [disablePname, setDisablePname] = useState(false);
  const [disableFname, setDisableFname] = useState(false);
  const [disableLname, setDisableLname] = useState(false);
  const [disablePid, setDisablePid] = useState(false);

  const [level, setLevel] = useState("");
  const [source, setSource] = useState("");

  const [value, setValue] = useState(0);
  // const [showCard1, setShowCard1] = useState(false)
  const [personalInformation, setPersonalInformation] = useState(false);

  // const [showCard2, setShowCard2] = useState(false)
  const [consentForm, setConsentForm] = useState(false);

  const [permissionEmail, setPermissionEmail] = useState(false);

  const pathItems = [
    { name: "หน้าหลัก", url: `/` },
    { name: "จัดการข้อมูลส่วนตัว", url: `${role ?? ""}/manageinfo` },
  ];
  let genderList = [
    {
      key: "male",
      value: "ชาย",
    },
    {
      key: "female",
      value: "หญิง",
    },
  ];
  let pnameList = [
    {
      key: "นาย",
      value: "นาย",
    },
    {
      key: "นาง",
      value: "นาง",
    },
    {
      key: "นางสาว",
      value: "นางสาว",
    },
  ];

  useEffect(() => {
    if (location.state?.message) {
      setIsMessage({ data: location.state?.message, type: "warning" });
    }

    getDataUser();
  }, []);

  useEffect(() => {
    getProvinceList();
    getHospitalList();
  }, []);

  const getDataUser = async () => {
    setLoading(true);
    let res = await userApi.data();
    setLoading(false);
    if (res) {
      // console.log(
      //   "hospital",
      //   res["data"]["user_data"]["hospital"]["hospital_name"],
      // );
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setLevel(
          res["data"]["user_data"]["auth"]["ial"]["level"]
            ? res["data"]["user_data"]["auth"]["ial"]["level"]
            : res["data"]["user_data"]["auth"]["ial"],
        );
        setSource(res["data"]["user_data"]["auth"]["ial"]["source"]);
        setPname(res["data"]["user_data"]["pname"]);
        setFname(res["data"]["user_data"]["fname"]);
        setLname(res["data"]["user_data"]["lname"]);
        setPid(res["data"]["user_data"]["pid"]);
        setGender(res["data"]["user_data"]["gender"]);
        setBirthday(res["data"]["user_data"]["birthday"]);
        // setBirthday(moment(res['data']['user_data']['birthday']).add(543, 'years').format('DD MMMM YYYY'))
        setAddress(res["data"]["user_data"]["current_address"]["address"]);
        setBuilding(res["data"]["user_data"]["current_address"]["building"]);
        setMoo(res["data"]["user_data"]["current_address"]["village_number"]);
        setPostCode(res["data"]["user_data"]["current_address"]["post_code"]);
        setProvinceId(
          res["data"]["user_data"]["current_address"]["province_id"],
        );
        getDistrictList(
          res["data"]["user_data"]["current_address"]["province_id"],
        );
        setDistrictId(
          res["data"]["user_data"]["current_address"]["district_id"],
        );
        getSubDistrictList(
          res["data"]["user_data"]["current_address"]["district_id"],
        );
        setSubDistrictId(
          res["data"]["user_data"]["current_address"]["sub_district_id"],
        );
        setEmail(res["data"]["user_data"]["email"]);
        setPhoneNumber(res["data"]["user_data"]["phone_number"]);
        setHospitalId(res["data"]["user_data"]["hospital"]["hospital_id"]);
        // setHospitalId(res["data"]["user_data"]["hospital"]["hospital_name"]);
        setLisenceNumber(res["data"]["user_data"]["license_number"]);
        setPersonalInformation(
          res["data"]["user_data"]["permission"]["policy_personal_information"],
        );
        setConsentForm(res["data"]["user_data"]["permission"]["consent_form"]);
        setPermissionEmail(
          res["data"]["user_data"]["permission"]["access_to_email"],
        );

        localStorage.setItem("user", JSON.stringify(res["data"]["user_data"]));

        const currentOrigin = window.location.origin;
        const getBaseUrl = currentOrigin.includes('dmsc.moph.go.th') 
          ? currentOrigin 
          : 'https://dmsc-static.devfunction.com';
        const imageSrc = res["data"]["user_data"]?.["profile_image"] 
          && `${getBaseUrl}/image/${res["data"]["user_data"]?.["profile_image"]}`;
        setGetImgDefault(`${imageSrc}`);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateProfileData = async (
    phone_number,
    email,
    current_address,
    permission,
  ) => {
    let res = "";
    setLoading(true);
    res = await userApi.updateProfileData(
      phone_number,
      email,
      current_address,
      permission,
      hospitalId,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateProfileImage = async (targetfiles) => {
    let formData = new FormData();
    formData.append("image", targetfiles[0]);
    let res = "";
    setLoading(true);
    res = await userApi.updateProfileImage(formData);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        getDataUser();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getProvinceList = async () => {
    setLoading(true);
    let res = await publicApi.getProvinceList();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setProvinceList(
          res["data"]["province_list"].map((item) => {
            return {
              key: item["province_id"],
              value: item["province_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDistrictList(
          res["data"]["district_list"].map((item) => {
            return {
              key: item["district_id"],
              value: item["district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getSubDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getSubDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setSubDistrictList(
          res["data"]["sub_district_list"].map((item) => {
            return {
              key: item["sub_district_id"],
              value: item["sub_district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getHospitalList = async () => {
    setLoading(true);
    let res = await publicApi.getHospitalList();
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setHospitalList(
          res["data"]["hospital_list"].map((item) => {
            return {
              id: item["hospital_id"],
              name: item["hospital_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onSelectFile = (e) => {
    if (e !== "") {
      // console.log(e.target.files)
      const uploadFiles = e.target.files;
      createUrlBlobFile(uploadFiles);
      updateProfileImage(uploadFiles);
    }
  };

  const createUrlBlobFile = (uploadFiles) => {
    const uploadFilesImageList = Array.from(uploadFiles);

    const imageData = uploadFilesImageList.map((file) => {
      return {
        name: file["name"],
        url: URL.createObjectURL(file),
      };
    });
    setShowImageList(imageData);
  };

  const clickGetOauthUrl = async () => {
    setLoading(true);
    let res =
      await uplevelApi.getOauthVerifyIdentityThaiID("MEDICAL_PERSONNEL");
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]["auth_url"]);
        window.open(res["data"]["auth_url"], "_system");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const submitButtonClick = () => {
    if (!pname) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
      return;
    }
    if (!lisenceNumber) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเลขใบประกอบวิชาชีพ" });
      return;
    }
    if (hospitalId == "") {
      setIsMessage({ type: "warning", data: "กรุณากรอกโรงพยาบาลต้นสังกัด" });
      return;
    }
    if (!address) {
      setIsMessage({ type: "warning", data: "กรุณากรอกที่อยู่" });
      return;
    }
    if (!moo) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหมู่" });
      return;
    }
    if (!postCode) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
      return;
    }
    if (!provinceId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกจังหวัด" });
      return;
    }
    if (!districtId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกอำเภอ" });
      return;
    }
    if (!subDistrictId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกตำบล" });
      return;
    }
    if (!phoneNumber) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทร" });
      return;
    }
    if (!email) {
      setIsMessage({ type: "warning", data: "กรุณากรอก Email" });
      return;
    }
    if (!consentForm || !personalInformation) {
      setIsMessage({ type: "warning", data: "กรุณา ยินยอมให้เข้าถึงข้อมูล" });
      return;
    } else {
      let current_address = {
        address: address,
        building: building,
        village_number: moo,
        alley: "-",
        road: road ?? "-",
        sub_district_id: subDistrictId,
        district_id: districtId,
        province_id: provinceId,
        post_code: postCode,
      };
      let permission = {
        access_data_every_time: false,
        access_data_some_time: false,
        consent_form: consentForm,
        policy_personal_information: personalInformation,
        access_to_email: permissionEmail,
      };

      updateProfileData(phoneNumber, email, current_address, permission);
    }
  };

  //   return (
  //     <div className='global-page'>
  //       <HeadBar />
  //       <HashLoader disabled loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" />
  //       <PageHeader titlename={'จัดการข้อมูลส่วนตัว'} btnBackWard backpath={'/searchDataPatient'} />
  //       <div style={{
  //         display: 'grid',
  //         gridTemplateColumns: '1fr 1fr',
  //         cursor: 'pointer'
  //       }}>
  //         <div onClick={() => { setValue(0) }} className={value === 0 ? styles.tab : styles.tabN}>ข้อมูลส่วนตัว</div>
  //         <div onClick={() => { setValue(1) }} className={value === 1 ? styles.tab : styles.tabN}>แบบฟอร์มยินยอมให้เปิดเผยข้อมูล</div>
  //       </div>

  //       <div className='mb-10'>
  //         {value === 0 ?
  //           <div className='flex justify-center'>
  //             <div className='flex lg:flex-col w-full'>
  //               <div className='flex flex-col lg:items-center lg:mr-0 mr-10'>
  //                 {
  //                   showImageList.length > 0 ? <>
  //                     {showImageList.map((i, idx) => {
  //                       return (
  //                         <img key={idx} className='drop-shadow-lg w-[280px] rounded-2xl h-[200px] mb-10' src={i['url']} style={{ objectFit: 'contain' }} alt="" />
  //                       )
  //                     })}
  //                   </> : <>
  //                     {
  //                       getImgDefault ? <>
  //                         <img className='drop-shadow-lg w-[280px] h-[200px] mb-10 rounded-2xl' src={getImgDefault} style={{ objectFit: 'contain' }} alt="" />
  //                       </> : <img className='drop-shadow-lg w-56 h-56' src={require('../../../asset/image/image-user.svg').default} alt="" />
  //                     }
  //                   </>
  //                 }
  //                 <section>
  //                   <label>
  //                     <div className='flex justify-center items-center h-10 rounded-full bg-[#B9DFC5] text-[#000000] hover:ring-2 ring-[#B9DFC5] active:scale-90 transition-all duration-100 ease-in-out shadow-md lg:mb-8 lg:w-[200px]'>อัปโหลดรูปภาพ</div>
  //                     <input
  //                       type="file"
  //                       accept="image/png ,image/jpeg"
  //                       name='images'
  //                       style={{ display: 'none' }}
  //                       onChange={(e) => { onSelectFile(e) }} />
  //                   </label>
  //                 </section>

  //               </div>

  //               <div style={{ width: '100%' }}>
  //                 <p style={{ marginTop: '20px' }} className='pb-2 border-b border-[#B9DFBA] font-semibold mb-6'>ระดับการพิสูจน์ตัวตน</p>
  //                 <div className={styles.Input2}>
  //                   <Input disabled value={level} setValue={setLevel}></Input>
  //                   <div className={styles.buttonLevel}>
  //                     <button className='flex gap-4 justify-center items-center  h-12 w-64 md:h-10 md:w-60 lg:h-10 lg:w-60 lg:gap-1 rounded-full bg-[#B9DFC5] text-[#000000] hover:ring-2 ring-[#B9DFC5] active:scale-90 transition-all duration-100 ease-in-out shadow-md'
  //                       onClick={() => {
  //                         window.open(`${ENDPOINT_MOHPROMT}/oauth/redirect?client_id=${ENDPOINT_MOHPROMT_CLIENT_ID}&redirect_uri=${REDIRECT_DOMAIN}/upLevelByMohPromt&response_type=code`, '_system')
  //                       }}
  //                     >
  //                       <img style={{ width: 35 }} src={iconDID} />
  //                       <div >เพิ่มระดับการพิสูจน์ตัวตน</div>
  //                     </button>

  //                     <Tooltip
  //                       placement="top"
  //                       className="bg-white px-4 py-3 w-[400px]"
  //                       content={
  //                         <div>
  //                           <Typography
  //                             variant="small"
  //                             color="blue-gray"
  //                             className="text-[16px] opacity-80"
  //                           >
  //                             เพิ่มระดับการยืนยันตัวตนให้มีระดับ 2 ขึ้นไป เพื่อให้สามารถเข้าถึงข้อมูลผลการตรวจได้
  //                           </Typography>
  //                         </div>
  //                       }
  //                     >
  //                       <img className={styles.Img} src={icon} />
  //                     </Tooltip>
  //                   </div>
  //                 </div>

  //                 <p style={{ marginTop: '20px' }} className='pb-2 border-b border-[#B9DFBA] font-semibold mb-6'>ข้อมูลส่วนตัว</p>
  //                 <div className={styles.Input}>
  //                   <Input disabled placeholder="คำนำหน้า" value={pname} setValue={setPname}></Input>
  //                   <Input disabled placeholder="ชื่อ" value={fname} setValue={setFname}></Input>
  //                   <Input disabled placeholder="นามสกุล" value={lname} setValue={setLname}></Input>
  //                   <Input disabled placeholder="เลขบัตรประจำตัวประชาชน" value={pid} setValue={setPid}></Input>
  //                   <Input disabled placeholder="วัน เดือน ปีเกิด" value={birthday} setValue={setBirthday}></Input>
  //                   <div></div>
  //                   <Input disabled placeholder="เลขใบประกอบวิชาชีพ" value={lisenceNumber} setValue={setLisenceNumber}></Input>
  //                   <Input disabled placeholder="ชื่อโรงพยาบาลต้นสังกัด" value={hospitalId} setValue={setHospitalId}></Input>
  //                 </div>

  //                 <p style={{ marginTop: '20px' }} className='pb-2 border-b border-[#B9DFBA] font-semibold mb-6'>ที่อยู่โรงพยาบาล</p>
  //                 <div className={styles.Input}>
  //                   <Input placeholder="บ้านเลขที่" value={address} setValue={setAddress}></Input>
  //                   <Input placeholder="หมู่" value={moo} setValue={setMoo}></Input>
  //                   <Input placeholder="รหัสไปรษณีย์" value={postCode} setValue={setPostCode}></Input>
  //                   <div>
  //                     <Select placeholder="จังหวัด" value={provinceId} setValue={(e) => {
  //                       setProvinceId(e)
  //                       setDistrictId('')
  //                       setDistrictList([])
  //                       setSubDistrictId('')
  //                       setSubDistrictList([])
  //                       getDistrictList(e)
  //                     }} list={provinceList}></Select>
  //                   </div>
  //                   <div>
  //                     <Select placeholder="อำเภอ" value={districtId} setValue={(e) => {
  //                       setDistrictId(e)
  //                       setSubDistrictId('')
  //                       setSubDistrictList([])
  //                       getSubDistrictList(e)
  //                     }} list={districtList}></Select>
  //                   </div>
  //                   <div>
  //                     <Select placeholder="ตำบล" value={subDistrictId} setValue={setSubDistrictId} list={subDistrictList}></Select>
  //                   </div>
  //                 </div>

  //                 <p style={{ marginTop: '20px' }} className='pb-2 border-b border-[#B9DFBA] font-semibold mb-6'>ข้อมูลติดต่อ</p>
  //                 <div className={styles.Input}>
  //                   <Input label='Email (ถ้ามี)' placeholder="E-mail" value={email} setValue={setEmail}></Input>
  //                   <Input placeholder="โทรศัพท์" value={phoneNumber} setValue={setPhoneNumber}></Input>
  //                 </div>

  //                 <div className='flex justify-center mt-12 w-full'>
  //                   <button onClick={submitButtonClick} className='h-12 w-64 rounded-full bg-[#B9DFC5] text-[#000000] hover:ring-2 ring-[#B9DFC5] active:scale-90 transition-all duration-100 ease-in-out shadow-md'><p>บันทึกการแก้ไข</p></button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           :
  //           <div className={stylesPer.content} style={{marginTop: 0, padding: 0}}>
  //             <div className={stylesPer.card}>
  //               <div className={stylesPer.mainCard}>
  //                 <Checkbox id="checkbox1" value={personalInformation} />
  //                 <div className={stylesPer.text}>นโยบายคุ้มครองข้อมูลส่วนบุคคล</div>
  //                 <img onClick={() => { setShowCard1(!showCard1) }} className={`${showCard1 ? stylesPer.active : ''}`} src={require('../../../asset/icon/chevron-down.svg').default}></img>
  //               </div>
  //               <div className={`${stylesPer.detailCard} ${showCard1 ? stylesPer.detailActive : ''}`}>
  //                 <div>
  //                   “ผูกพันธุ์” คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์ หรือแอปพลิเคชัน ผูกพันธุ์
  //                   <div className={stylesPer.return}></div>

  //                   นอกจากนี้ แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์ นำร่อง 4 การทดสอบ ได้แก่
  //                   <div></div>
  //                   การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น แพ้ยาที่เกิดจากการได้รับยา Allopurinol
  //                   <div></div>
  //                   การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา Carbamazepine
  //                   <div></div>
  //                   การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา Abacavir (Abacavir hypersensitivity reaction)
  //                   <div></div>
  //                   การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
  //                   <div className={stylesPer.return}></div>

  //                   โรงพยาบาล /ห้องปฏิบัติการอื่นๆ สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้
  //                   เนื่องจากการตรวจ บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา ต่างโรงพยาบาล และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
  //                   ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
  //                   <div className={stylesPer.return}></div>

  //                   “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์
  //                   <div></div>
  //                   “ผู้ใช้บริการ” หมายความถึง ผู้สมัครใช้บริการระบบ
  //                   <div className={stylesPer.return}></div>

  //                   ผู้ให้บริการ และ ผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
  //                   <div className={stylesPer.return}></div>

  //                   1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย ทั้งนี้ ผู้ใช้บริการสามารถ ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
  //                   <div></div>
  //                   2. ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน ไม่ถูกต้อง หรือเป็นข้อมูลเท็จ ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท เลินเล่อก็ตาม ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
  //                   <div></div>
  //                   3. ในการใช้บริการบางกรณี ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้ e-Mail หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
  //                   <div></div>
  //                   4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
  //                   <div></div>
  //                   5. ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
  //                   <div></div>
  //                   6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า หรือกระทำการอื่นใด นอกจาก การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
  //                   <div></div>
  //                   7. ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้ ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
  //                   <div></div>
  //                   8. ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ ผู้ให้บริการ ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560 , พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ ความผิดทางวินัยด้วยแล้วแต่กรณี
  //                   <div></div>
  //                   9. การแก้ไข เปลี่ยนแปลง หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้ ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ ตามความเหมาะสม กับสถานการณ์
  //                   <div className={styles.return}></div>

  //                   ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
  //                 </div>
  //               </div>
  //             </div>
  //             <div className={stylesPer.card}>
  //               <div className={stylesPer.mainCard} >
  //                 <Checkbox id="checkbox2" value={consentForm}/>
  //                 <div className={stylesPer.text}>แบบฟอร์มยินยอมให้เปิดเผยข้อมูล</div>
  //                 <img onClick={() => { setShowCard2(!showCard2) }} className={`${showCard2 ? stylesPer.active : ''}`} src={require('../../../asset/icon/chevron-down.svg').default}></img>
  //               </div>
  //               <div className={`${stylesPer.detailCard} ${showCard2 ? stylesPer.detailActive : ''}`}>
  //                 <div>
  //                   ข้าพเจ้าให้สัญญา ตกลงจะรักษาความลับข้อมูลด้านสุขภาพของผู้รับบริการ อาทิ รายการ และ/ หรือรายละเอียด และ/ หรือภาพ และ/ หรือข้อมูลใด ๆ ที่เกี่ยวข้องกับข้อมูลด้านสุขภาพของบุคคล ตาม พรบ. สุขภาพแห่งชาติ พ.ศ. 2550 มาตรา 7
  //                   <div className={stylesPer.return}></div>
  //                   “ข้อมูลด้านสุขภาพของบุคคล เป็นความลับส่วนบุคคล นำไป เปิดเผยในประการที่จะทำให้บุคคลนั้นเสียหายไม่ได้ เว้นแต่การเปิดเผยนั้นเป็นไปตามความ ประสงค์ของบุคคลนั้นโดยตรง หรือมีกฎหมายเฉพาะบัญญัติให้ต้อง เปิดเผย แต่ไม่ว่าในกรณีใด ๆ ผู้ใดจะอาศัยอำนาจหรือสิทธิ ตามกฎหมายว่าด้วยข้อมูล ข่าวสารของราชการ หรือกฎหมายอื่นเพื่อขอเอกสารเกี่ยวกับข้อมูลด้าน สุขภาพของบุคคลที่ไม่ใช่ของตนไม่ได้”
  //                   และประมวลกฎหมายอาญา มาตรา 323 บัญญัติ ไว้ว่า
  //                   <div className={stylesPer.return}></div>
  //                   “ผู้ใดล่วงรู้หรือได้มาซึ่งความลับของผู้อื่นโดยเหตุที่เป็นเจ้าพนักงานผู้มีหน้าที่ โดยเหตุที่ประกอบอาชีพแพทย์ เภสัชกร คนจำหน่ายยา นางผดุงครรภ์ ผู้พยาบาล นักบวช หมอความ ทนายความหรือผู้สอบบัญชีหรือโดยเหตุที่เป็นผู้ช่วยในการประกอบอาชีพนั้น แล้วเปิดเผยความลับนั้นในประการที่น่าจะเกิดความ เสียหายแก่ผู้หนึ่งผู้ใด ต้องระวางโทษจำคุกไม่เกินหกเดือน หรือปรับไม่เกินหนึ่งพันบาท หรือทั้งจำทั้งปรับ”
  //                   <div className={stylesPer.return}></div>

  //                   ข้าพเจ้าตกลงรักษาข้อมูลที่เป็นความลับและไม่เปิดเผยข้อมูลของผู้ป่วย
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         }
  //       </div>
  //     </div>

  //   )

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <div className="flex flex-col gap-2 items-center w-full pb-5 mt-[50px]">
          <h1 className="md:text-2xl flex text-3xl font-bold">
            จัดการข้อมูลส่วนตัว
          </h1>
          <span className="sm:text-lg flex text-xl font-bold">
            กรุณากรอกข้อมูลให้ครบถ้วน
          </span>
          <span className="sm:text-sm sm:font-normal flex text-lg font-bold">
            เพิ่มข้อมูลที่อยู่และตั้งค่าบัญชีเพื่อเข้าใช้งานในครั้งถัดไป
          </span>
        </div>
        <div className="2sm:flex-col flex flex-row gap-6 w-full">
          <div className="2sm:w-full flex flex-col gap-2 items-center w-[20%] max-h-[380px] text-nowrap">
            <div className="overflow-hidden aspect-square rounded-md">
              {showImageList.length > 0 ? (
                <>
                  {showImageList.map((i, idx) => {
                    return <img key={idx} src={i["url"]} alt="" />;
                  })}
                </>
              ) : (
                <>
                  {getImgDefault ? (
                    <>
                      <img src={getImgDefault} alt="" />
                    </>
                  ) : (
                    <img
                      className="aspect-square object-cover"
                      src={
                        require("../../../asset/image/image-user.svg").default
                      }
                      alt=""
                    />
                  )}
                </>
              )}
            </div>
            <section>
              <label className="lg:text-xs flex flex-row justify-center items-center gap-2 w-full px-6 py-2 rounded-md text-white text-base bg-[#4F9C9D] cursor-pointer">
                <FontAwesomeIcon icon={faArrowDown} />
                <span>อัปโหลดไฟล์</span>
                <input
                  type="file"
                  accept="image/png ,image/jpeg"
                  name="images"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    onSelectFile(e);
                  }}
                />
              </label>
            </section>
            <div className="lg:text-xs flex flex-col gap-1 justify-center items-center w-full text-base">
              <span>อัปโหลดไฟล์</span>
              <span>สกุล jpg, png</span>
              <span>ขนาดไฟล์ไม่เกิน 10 MB</span>
            </div>
          </div>
          <div className="2sm:w-full flex flex-col gap-4 w-[70%] h-full">
            <div className="flex flex-col gap-2 py-2 w-full">
              <div className="flex flex-row gap-2">
                <span className="lg:text-lg text-xl font-bold">
                  เลือกระดับการพิสูจน์ตัวตน
                </span>
                <Tooltip
                  placement="top"
                  className="bg-white px-4 py-3 w-[400px]"
                  content={
                    <div>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="text-[16px] opacity-80"
                      >
                        เพิ่มระดับการยืนยันตัวตนให้มีระดับ 2 ขึ้นไป
                        เพื่อให้สามารถเข้าถึงข้อมูลผลการตรวจได้
                      </Typography>
                    </div>
                  }
                >
                  <img className="lg:w-5 lg:h-5 w-6 h-6" src={icon} />
                </Tooltip>
              </div>
              {level > 2 ? (
                <div className="sm:grid-cols-1 grid grid-flow-dense grid-cols-2 pb-2 gap-5 w-full">
                  <div className="flex flex-row gap-2 w-full">
                    {source === "THAI_D" ? (
                      <img style={{ width: 35 }} src={iconThaiID} />
                    ) : (
                      <img style={{ width: 35 }} src={iconDID} />
                    )}
                    <div className="w-full h-full px-5 py-[7px] text-nowrap rounded-md border border-[#A2B5BC]">
                      IAL : Level {level}
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="sm:w-[65%] w-[49%] h-full px-5 py-[7px] text-nowrap rounded-md border border-[#A2B5BC]">
                    IAL : Level {level}
                  </div>
                  <div className="flex flex-row gap-5 justify-between">
                    <div className="2xl:flex-col 2xl:w-[70%] 2lg:min-w-[340px] flex flex-row gap-3 justify-between w-full pb-2 text-nowrap">
                      <div className="flex w-full p-2 rounded-md border border-gray-300 cursor-pointer">
                        <button
                          className="flex gap-4 items-center lg:gap-1 md:text-[12px]"
                          onClick={() => {
                            clickGetOauthUrl();
                          }}
                        >
                          <img style={{ width: 35 }} src={iconThaiID} />
                          <div className="lg:text-sm lg:font-normal text-blue-700 font-bold">
                            เพิ่มระดับการพิสูจน์ตัวตนด้วย ThaID
                          </div>
                        </button>
                      </div>
                      <div className="flex w-full p-2 rounded-md border border-gray-300 cursor-pointer">
                        <button
                          className="flex gap-4 items-center lg:gap-1 md:text-[12px]"
                          onClick={() => {
                            window.open(
                              `${ENDPOINT_MOHPROMT}/oauth/redirect?client_id=${ENDPOINT_MOHPROMT_CLIENT_ID}&redirect_uri=${REDIRECT_DOMAIN}/upLevelByMohPromt&response_type=code`,
                              "_system",
                            );
                          }}
                        >
                          <img style={{ width: 35 }} src={iconDID} />
                          <div className="lg:text-sm lg:font-normal text-[#358335] font-bold">
                            เพิ่มระดับการพิสูจน์ตัวตนด้วยหมอพร้อม DID
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="flex flex-col gap-1 py-2 w-full">
              <span className="lg:text-base text-xl font-bold">
                ข้อมูลส่วนตัว
              </span>
              <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
                <div className="w-full">
                  <Select
                    label="เลือกคำนำหน้า"
                    value={pname}
                    setValue={setPname}
                    disabled
                    list={pnameList}
                    placeholder="เลือกคำนำหน้า"
                  ></Select>
                </div>
                <div className="w-full"></div>
                <div className="w-full">
                  <Input
                    label="ชื่อ"
                    placeholder="ชื่อ"
                    value={fname}
                    disabled
                    setValue={setFname}
                  ></Input>
                </div>
                <div className="w-full">
                  <Input
                    label="นามสกุล"
                    placeholder="นามสกุล"
                    value={lname}
                    disabled
                    setValue={setLname}
                  ></Input>
                </div>
                <div className="w-full">
                  <Input
                    regex={regex.pid()}
                    label="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
                    disabled={true}
                    placeholder="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
                    value={pid}
                    setValue={setPid}
                  ></Input>
                </div>
                <div className="w-full">
                  <Select
                    label="เพศ"
                    placeholder="เพศ"
                    value={gender}
                    setValue={setGender}
                    disabled={true}
                    list={genderList}
                  ></Select>
                </div>
                <div className="w-full">
                  {/* <Datepicker label="วันเกิด" value={birthday} setValue={setBirthday} disabled ></Datepicker> */}
                  <Input
                    regex={regex.pid()}
                    label="วันเกิด"
                    disabled={true}
                    placeholder="วันเกิด"
                    value={birthday}
                  ></Input>
                </div>
                <div className="w-full">
                  <AutoComplete
                    id={hospitalId}
                    placeholder="โรงพยาบาลต้นสังกัด"
                    label="โรงพยาบาลต้นสังกัด"
                    list={hospitalList}
                    callBack={(res) => {
                      setHospitalId(res["id"]);
                    }}
                  ></AutoComplete>
                  {/* <Input disabled={true} label="โรงพยาบาลต้นสังกัด" placeholder="โรงพยาบาลต้นสังกัด" value={hospitalId} setValue={setHospitalId}></Input> */}
                </div>
                <div className="w-full">
                  <Input
                    disabled
                    placeholder="เลขใบประกอบวิชาชีพ"
                    label="เลขใบประกอบวิชาชีพ"
                    value={lisenceNumber}
                    setValue={setLisenceNumber}
                  ></Input>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2 py-2 w-full">
              <span className="lg:text-base text-xl font-bold">
                ที่อยู่ปัจจุบัน
              </span>
              <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
                <div className="w-full">
                  <Input
                    placeholder="บ้านเลขที่"
                    label="บ้านเลขที่"
                    value={address}
                    setValue={setAddress}
                  ></Input>
                </div>
                <div className="w-full">
                  <Input
                    placeholder="อาคาร/ตึก/ชั้น"
                    label="อาคาร/ตึก/ชั้น"
                    value={building}
                    setValue={setBuilding}
                  ></Input>
                </div>
                <div className="w-full">
                  <Input
                    placeholder="หมู่"
                    label="หมู่"
                    value={moo}
                    setValue={setMoo}
                  ></Input>
                </div>
                {/* <div className="w-full">
                                <Input placeholder="ตรอก/ซอย" value={alley} setValue={setAlley}></Input>
                            </div>
                            <div className="w-full">
                                <Input placeholder="ถนน" value={road} setValue={setRoad}></Input>
                            </div> */}
                <div className="w-full">
                  <Select
                    label="จังหวัด"
                    placeholder="จังหวัด"
                    value={provinceId}
                    setValue={(e) => {
                      setProvinceId(e);
                      setDistrictId("");
                      setDistrictList([]);
                      setSubDistrictId("");
                      setSubDistrictList([]);
                      getDistrictList(e);
                    }}
                    list={provinceList}
                  ></Select>
                </div>
                <div className="w-full">
                  <Select
                    label="อำเภอ"
                    placeholder="อำเภอ"
                    value={districtId}
                    setValue={(e) => {
                      setDistrictId(e);
                      setSubDistrictId("");
                      setSubDistrictList([]);
                      getSubDistrictList(e);
                    }}
                    list={districtList}
                  ></Select>
                </div>
                <div className="w-full">
                  <Select
                    label="ตำบล"
                    placeholder="ตำบล"
                    value={subDistrictId}
                    setValue={setSubDistrictId}
                    list={subDistrictList}
                  ></Select>
                </div>
                <div className="w-full">
                  <Input
                    placeholder="รหัสไปรษณีย์"
                    label="รหัสไปรษณีย์"
                    value={postCode}
                    setValue={setPostCode}
                  ></Input>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-1 py-2 w-full">
              <span className="lg:text-base text-xl font-bold">
                ข้อมูลติดต่อ
              </span>
              <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
                <div className="w-full">
                  <Input
                    placeholder="หมายเลขโทรศัพท์"
                    label="หมายเลขโทรศัพท์"
                    value={phoneNumber}
                    setValue={setPhoneNumber}
                  ></Input>
                </div>
                <div className="w-full">
                  <Input
                    placeholder="อีเมล"
                    label="อีเมล"
                    value={email}
                    setValue={setEmail}
                  ></Input>
                </div>
              </div>
            </div>
            <div className="mt-[1rem]">
              <span className="lg:text-base text-xl font-bold">
                ยินยอมการเข้าถึงแจ้งเตือนผ่าน Email
              </span>
            </div>
            <CheckBoxV3
              id="checkbox3"
              value={permissionEmail}
              setValue={setPermissionEmail}
              label="ยินยอมการเข้าสู่ระบบผ่าน Email"
            />
            <div className="mt-[1rem]">
              <span className="lg:text-base text-xl font-bold">
                ยินยอมอนุญาตการเปิดเผยและเข้าถึงข้อมูล
              </span>
            </div>
            <CheckBoxV3
              id="checkbox1"
              value={personalInformation}
              setValue={setPersonalInformation}
              label='การยินยอมให้แลกเปลี่ยนข้อมูลกับระเบียนสุขภาพส่วนบุคคลที่เชื่อมต่อกับระบบ "ผูกพันธ์ุ"'
            />
            <CheckBoxV3
              id="checkbox2"
              value={consentForm}
              setValue={setConsentForm}
              label="ยินยอมในการให้ข้อมูลการตรวจทางพันธุกรรมที่มาจากระบบสารสนเทศของโรงพยาบาล การตรวจจากห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์ และระบบอื่น ๆ สามารถใช้แลกเปลี่ยนและจัดเก็บในระบผูกพันธุ์ได้"
            />
          </div>
        </div>
        <div className="flex justify-center mt-12 w-full">
          <button
            onClick={submitButtonClick}
            className="h-12 w-64 bg-blue-500 text-white rounded-md shadow-md cursor-pointer md:w-[140px] md:text-[12px] md:h-8"
          >
            <p>บันทึก</p>
          </button>
        </div>
      </div>
    </>
  );
}

export default ManageInfo;
